/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddPaymentMethodRequest,
    AddPaymentMethodRequestV2,
    AddPaymentMethodResponse,
    AddPaymentMethodResponseV3,
    BraintreeTokenResponse,
    ConfirmSetupCreatorSubscriptionPaymentMethodRequest,
    ConfirmSetupCreatorSubscriptionPaymentMethodResponse,
    ConfirmSetupSaasSubscriptionPaymentMethodRequest,
    ConfirmSetupSaasSubscriptionPaymentMethodResponse,
    CreateAccountLinkRequest,
    CreateAccountLinkResponse,
    CreateBillingAddressRequest,
    CreateCustomerAccountRequest,
    CreateStripeCustomerSessionResponse,
    GetLatestPaymentMethodsResponse,
    GetPaymentMethodByCardTokenResponse,
    GetPaymentMethodsResponse,
    GetStripeAccountInfoResponse,
    IdResponse,
    SetPaymentMethodBillingAddressRequest,
    UpdatePaymentMethodProviderRequest,
} from '../models';

export interface PaymentApiControllerAddPaymentMethodRequest {
    userId: string;
    addPaymentMethodRequest: AddPaymentMethodRequest;
}

export interface PaymentApiControllerAddPaymentMethodV2Request {
    userId: string;
    addPaymentMethodRequestV2: AddPaymentMethodRequestV2;
}

export interface PaymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethodRequest {
    sellerId: string;
    confirmSetupCreatorSubscriptionPaymentMethodRequest: ConfirmSetupCreatorSubscriptionPaymentMethodRequest;
}

export interface PaymentApiControllerConfirmSetupSaasSubscriptionPaymentMethodRequest {
    userId: string;
    confirmSetupSaasSubscriptionPaymentMethodRequest: ConfirmSetupSaasSubscriptionPaymentMethodRequest;
}

export interface PaymentApiControllerCreateAccountLinkRequest {
    userId: string;
    createAccountLinkRequest: CreateAccountLinkRequest;
}

export interface PaymentApiControllerCreateBillingAddressRequest {
    userId: string;
    createBillingAddressRequest: CreateBillingAddressRequest;
}

export interface PaymentApiControllerCreatePaymentMethodSecretRequest {
    userId: string;
}

export interface PaymentApiControllerCreateStripeCustomerSessionRequest {
    userId: string;
    createCustomerAccountRequest: CreateCustomerAccountRequest;
}

export interface PaymentApiControllerEditPaymentMethodRequest {
    userId: string;
    paymentId: string;
    setPaymentMethodBillingAddressRequest: SetPaymentMethodBillingAddressRequest;
}

export interface PaymentApiControllerGetLastestPaymentMethodRequest {
    userId: string;
}

export interface PaymentApiControllerGetPaymentMethodByCardTokenRequest {
    userId: string;
    cardToken: string;
    isSubscriptionPayment?: boolean;
}

export interface PaymentApiControllerGetPaymentMethodsRequest {
    userId: string;
}

export interface PaymentApiControllerGetStripeAccountInfoRequest {
    sellerId: string;
}

export interface PaymentApiControllerRemovePaymentMethodRequest {
    userId: string;
    paymentId: string;
}

export interface PaymentApiControllerUpdatePaymentMethodProviderRequest {
    userId: string;
    paymentId: string;
    updatePaymentMethodProviderRequest: UpdatePaymentMethodProviderRequest;
}

/**
 * 
 */
export class PaymentApi extends runtime.BaseAPI {

    /**
     */
    async paymentApiControllerAddPaymentMethodRaw(requestParameters: PaymentApiControllerAddPaymentMethodRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerAddPaymentMethod.');
        }

        if (requestParameters.addPaymentMethodRequest === null || requestParameters.addPaymentMethodRequest === undefined) {
            throw new runtime.RequiredError('addPaymentMethodRequest','Required parameter requestParameters.addPaymentMethodRequest was null or undefined when calling paymentApiControllerAddPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/payment-methods`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addPaymentMethodRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerAddPaymentMethod(requestParameters: PaymentApiControllerAddPaymentMethodRequest): Promise<IdResponse> {
        const response = await this.paymentApiControllerAddPaymentMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerAddPaymentMethodV2Raw(requestParameters: PaymentApiControllerAddPaymentMethodV2Request): Promise<runtime.ApiResponse<AddPaymentMethodResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerAddPaymentMethodV2.');
        }

        if (requestParameters.addPaymentMethodRequestV2 === null || requestParameters.addPaymentMethodRequestV2 === undefined) {
            throw new runtime.RequiredError('addPaymentMethodRequestV2','Required parameter requestParameters.addPaymentMethodRequestV2 was null or undefined when calling paymentApiControllerAddPaymentMethodV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/users/{userId}/payment-methods`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addPaymentMethodRequestV2,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerAddPaymentMethodV2(requestParameters: PaymentApiControllerAddPaymentMethodV2Request): Promise<AddPaymentMethodResponse> {
        const response = await this.paymentApiControllerAddPaymentMethodV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethodRaw(requestParameters: PaymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethodRequest): Promise<runtime.ApiResponse<ConfirmSetupCreatorSubscriptionPaymentMethodResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling paymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethod.');
        }

        if (requestParameters.confirmSetupCreatorSubscriptionPaymentMethodRequest === null || requestParameters.confirmSetupCreatorSubscriptionPaymentMethodRequest === undefined) {
            throw new runtime.RequiredError('confirmSetupCreatorSubscriptionPaymentMethodRequest','Required parameter requestParameters.confirmSetupCreatorSubscriptionPaymentMethodRequest was null or undefined when calling paymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sellers/{sellerId}:confirm-setup-subscription-payment-method`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.confirmSetupCreatorSubscriptionPaymentMethodRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethod(requestParameters: PaymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethodRequest): Promise<ConfirmSetupCreatorSubscriptionPaymentMethodResponse> {
        const response = await this.paymentApiControllerConfirmSetupCreatorSubscriptionPaymentMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerConfirmSetupSaasSubscriptionPaymentMethodRaw(requestParameters: PaymentApiControllerConfirmSetupSaasSubscriptionPaymentMethodRequest): Promise<runtime.ApiResponse<ConfirmSetupSaasSubscriptionPaymentMethodResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerConfirmSetupSaasSubscriptionPaymentMethod.');
        }

        if (requestParameters.confirmSetupSaasSubscriptionPaymentMethodRequest === null || requestParameters.confirmSetupSaasSubscriptionPaymentMethodRequest === undefined) {
            throw new runtime.RequiredError('confirmSetupSaasSubscriptionPaymentMethodRequest','Required parameter requestParameters.confirmSetupSaasSubscriptionPaymentMethodRequest was null or undefined when calling paymentApiControllerConfirmSetupSaasSubscriptionPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}:confirm-setup-saas-subscription-payment-method`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.confirmSetupSaasSubscriptionPaymentMethodRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerConfirmSetupSaasSubscriptionPaymentMethod(requestParameters: PaymentApiControllerConfirmSetupSaasSubscriptionPaymentMethodRequest): Promise<ConfirmSetupSaasSubscriptionPaymentMethodResponse> {
        const response = await this.paymentApiControllerConfirmSetupSaasSubscriptionPaymentMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerCreateAccountLinkRaw(requestParameters: PaymentApiControllerCreateAccountLinkRequest): Promise<runtime.ApiResponse<CreateAccountLinkResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerCreateAccountLink.');
        }

        if (requestParameters.createAccountLinkRequest === null || requestParameters.createAccountLinkRequest === undefined) {
            throw new runtime.RequiredError('createAccountLinkRequest','Required parameter requestParameters.createAccountLinkRequest was null or undefined when calling paymentApiControllerCreateAccountLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/stripe-account-link`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createAccountLinkRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerCreateAccountLink(requestParameters: PaymentApiControllerCreateAccountLinkRequest): Promise<CreateAccountLinkResponse> {
        const response = await this.paymentApiControllerCreateAccountLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerCreateBillingAddressRaw(requestParameters: PaymentApiControllerCreateBillingAddressRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerCreateBillingAddress.');
        }

        if (requestParameters.createBillingAddressRequest === null || requestParameters.createBillingAddressRequest === undefined) {
            throw new runtime.RequiredError('createBillingAddressRequest','Required parameter requestParameters.createBillingAddressRequest was null or undefined when calling paymentApiControllerCreateBillingAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/billingAddress`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createBillingAddressRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerCreateBillingAddress(requestParameters: PaymentApiControllerCreateBillingAddressRequest): Promise<IdResponse> {
        const response = await this.paymentApiControllerCreateBillingAddressRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerCreatePaymentMethodSecretRaw(requestParameters: PaymentApiControllerCreatePaymentMethodSecretRequest): Promise<runtime.ApiResponse<AddPaymentMethodResponseV3>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerCreatePaymentMethodSecret.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/users/{userId}:createPaymentMethodSecret`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerCreatePaymentMethodSecret(requestParameters: PaymentApiControllerCreatePaymentMethodSecretRequest): Promise<AddPaymentMethodResponseV3> {
        const response = await this.paymentApiControllerCreatePaymentMethodSecretRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerCreateStripeCustomerSessionRaw(requestParameters: PaymentApiControllerCreateStripeCustomerSessionRequest): Promise<runtime.ApiResponse<CreateStripeCustomerSessionResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerCreateStripeCustomerSession.');
        }

        if (requestParameters.createCustomerAccountRequest === null || requestParameters.createCustomerAccountRequest === undefined) {
            throw new runtime.RequiredError('createCustomerAccountRequest','Required parameter requestParameters.createCustomerAccountRequest was null or undefined when calling paymentApiControllerCreateStripeCustomerSession.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/stripe-customer-session`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createCustomerAccountRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerCreateStripeCustomerSession(requestParameters: PaymentApiControllerCreateStripeCustomerSessionRequest): Promise<CreateStripeCustomerSessionResponse> {
        const response = await this.paymentApiControllerCreateStripeCustomerSessionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerEditPaymentMethodRaw(requestParameters: PaymentApiControllerEditPaymentMethodRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerEditPaymentMethod.');
        }

        if (requestParameters.paymentId === null || requestParameters.paymentId === undefined) {
            throw new runtime.RequiredError('paymentId','Required parameter requestParameters.paymentId was null or undefined when calling paymentApiControllerEditPaymentMethod.');
        }

        if (requestParameters.setPaymentMethodBillingAddressRequest === null || requestParameters.setPaymentMethodBillingAddressRequest === undefined) {
            throw new runtime.RequiredError('setPaymentMethodBillingAddressRequest','Required parameter requestParameters.setPaymentMethodBillingAddressRequest was null or undefined when calling paymentApiControllerEditPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/payment-methods/{paymentId}:setBillingAddress`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"paymentId"}}`, encodeURIComponent(String(requestParameters.paymentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setPaymentMethodBillingAddressRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerEditPaymentMethod(requestParameters: PaymentApiControllerEditPaymentMethodRequest): Promise<IdResponse> {
        const response = await this.paymentApiControllerEditPaymentMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async paymentApiControllerGenerateBraintreeTokenRaw(): Promise<runtime.ApiResponse<BraintreeTokenResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/braintree:create-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async paymentApiControllerGenerateBraintreeToken(): Promise<BraintreeTokenResponse> {
        const response = await this.paymentApiControllerGenerateBraintreeTokenRaw();
        return await response.value();
    }

    /**
     */
    async paymentApiControllerGetLastestPaymentMethodRaw(requestParameters: PaymentApiControllerGetLastestPaymentMethodRequest): Promise<runtime.ApiResponse<GetLatestPaymentMethodsResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerGetLastestPaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/lastest-payment-method`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerGetLastestPaymentMethod(requestParameters: PaymentApiControllerGetLastestPaymentMethodRequest): Promise<GetLatestPaymentMethodsResponse> {
        const response = await this.paymentApiControllerGetLastestPaymentMethodRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerGetPaymentMethodByCardTokenRaw(requestParameters: PaymentApiControllerGetPaymentMethodByCardTokenRequest): Promise<runtime.ApiResponse<GetPaymentMethodByCardTokenResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerGetPaymentMethodByCardToken.');
        }

        if (requestParameters.cardToken === null || requestParameters.cardToken === undefined) {
            throw new runtime.RequiredError('cardToken','Required parameter requestParameters.cardToken was null or undefined when calling paymentApiControllerGetPaymentMethodByCardToken.');
        }

        const queryParameters: any = {};

        if (requestParameters.isSubscriptionPayment !== undefined) {
            queryParameters['isSubscriptionPayment'] = requestParameters.isSubscriptionPayment;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/payment-method/{cardToken}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"cardToken"}}`, encodeURIComponent(String(requestParameters.cardToken))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerGetPaymentMethodByCardToken(requestParameters: PaymentApiControllerGetPaymentMethodByCardTokenRequest): Promise<GetPaymentMethodByCardTokenResponse> {
        const response = await this.paymentApiControllerGetPaymentMethodByCardTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerGetPaymentMethodsRaw(requestParameters: PaymentApiControllerGetPaymentMethodsRequest): Promise<runtime.ApiResponse<GetPaymentMethodsResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerGetPaymentMethods.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/payment-methods`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async paymentApiControllerGetPaymentMethods(requestParameters: PaymentApiControllerGetPaymentMethodsRequest): Promise<GetPaymentMethodsResponse> {
        const response = await this.paymentApiControllerGetPaymentMethodsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async paymentApiControllerGetStripeAccountInfoRaw(requestParameters: PaymentApiControllerGetStripeAccountInfoRequest): Promise<runtime.ApiResponse<GetStripeAccountInfoResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling paymentApiControllerGetStripeAccountInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/sellers/{sellerId}:get-stripe-account-info`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async paymentApiControllerGetStripeAccountInfo(requestParameters: PaymentApiControllerGetStripeAccountInfoRequest): Promise<GetStripeAccountInfoResponse> {
        const response = await this.paymentApiControllerGetStripeAccountInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async paymentApiControllerRemovePaymentMethodRaw(requestParameters: PaymentApiControllerRemovePaymentMethodRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerRemovePaymentMethod.');
        }

        if (requestParameters.paymentId === null || requestParameters.paymentId === undefined) {
            throw new runtime.RequiredError('paymentId','Required parameter requestParameters.paymentId was null or undefined when calling paymentApiControllerRemovePaymentMethod.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/payment-methods/{paymentId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"paymentId"}}`, encodeURIComponent(String(requestParameters.paymentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async paymentApiControllerRemovePaymentMethod(requestParameters: PaymentApiControllerRemovePaymentMethodRequest): Promise<void> {
        await this.paymentApiControllerRemovePaymentMethodRaw(requestParameters);
    }

    /**
     */
    async paymentApiControllerUpdatePaymentMethodProviderRaw(requestParameters: PaymentApiControllerUpdatePaymentMethodProviderRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling paymentApiControllerUpdatePaymentMethodProvider.');
        }

        if (requestParameters.paymentId === null || requestParameters.paymentId === undefined) {
            throw new runtime.RequiredError('paymentId','Required parameter requestParameters.paymentId was null or undefined when calling paymentApiControllerUpdatePaymentMethodProvider.');
        }

        if (requestParameters.updatePaymentMethodProviderRequest === null || requestParameters.updatePaymentMethodProviderRequest === undefined) {
            throw new runtime.RequiredError('updatePaymentMethodProviderRequest','Required parameter requestParameters.updatePaymentMethodProviderRequest was null or undefined when calling paymentApiControllerUpdatePaymentMethodProvider.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/users/{userId}/payment-methods/{paymentId}:updateProvider`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"paymentId"}}`, encodeURIComponent(String(requestParameters.paymentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updatePaymentMethodProviderRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async paymentApiControllerUpdatePaymentMethodProvider(requestParameters: PaymentApiControllerUpdatePaymentMethodProviderRequest): Promise<void> {
        await this.paymentApiControllerUpdatePaymentMethodProviderRaw(requestParameters);
    }

}
